import classNames from 'classnames';
import * as React from 'react';
import { useState } from 'react';
import type { ReactNode } from 'react';
import { Button } from '~/Partials/Button/Button';
import { Collapse } from '~/Partials/Collapse/Collapse';
import styles from './MenuSection.module.css';

interface MenuSectionTranslations {
    open: string;
    close: string;
}

interface MenuSectionProps {
    heading: string;
    translations: MenuSectionTranslations;
    children?: ReactNode;
}

interface MenuSectionState {
    isOpened: boolean;
}

export const MenuSection: React.FC<React.PropsWithChildren<MenuSectionProps>> = (props: MenuSectionProps) => {
    const [state, setState] = useState<MenuSectionState>({ isOpened: false });

    const toggle = () => {
        setState(prevState => ({ isOpened: !prevState.isOpened }));
    };

    const getChangeStateText = () => (state.isOpened ? props.translations.close : props.translations.open);

    const { heading, children } = props;

    return (
        <div className={classNames(state.isOpened && styles['Variant--opened'])}>
            <div className={styles.Heading}>
                {heading}
                {children && (
                    <Button
                        onClick={toggle}
                        className={styles.Button}
                        aria-haspopup="true"
                        aria-expanded={state.isOpened}
                    >
                        <span className="visuallyHidden">{getChangeStateText()}</span>
                    </Button>
                )}
            </div>

            <Collapse className={styles.ContentWrapper} isOpen={state.isOpened}>
                <div className={styles.Content}>{children}</div>
            </Collapse>
        </div>
    );
};
